import { AdditionFact } from './curriculum';

const NUMBER_WORDS: Record<number, string> = {
  0: 'zero',
  1: 'one',
  2: 'two',
  3: 'three',
  4: 'four',
  5: 'five',
  6: 'six',
  7: 'seven',
  8: 'eight',
  9: 'nine',
  10: 'ten',
};

/** "three plus one equals four" */
export function factToSpeechText(fact: AdditionFact): string {
  return `${NUMBER_WORDS[fact.addend1]} plus ${NUMBER_WORDS[fact.addend2]} equals ${NUMBER_WORDS[fact.sum]}`;
}

/** "3 + 1 = 4" */
export function factToDisplayText(fact: AdditionFact): string {
  return `${fact.addend1} + ${fact.addend2} = ${fact.sum}`;
}

/** "3 + 1 = ?" */
export function factToQuestionText(fact: AdditionFact): string {
  return `${fact.addend1} + ${fact.addend2} = ?`;
}

/** "What is two plus one?" */
export function factToQuestionSpeechText(fact: AdditionFact): string {
  return `What is ${NUMBER_WORDS[fact.addend1]} plus ${NUMBER_WORDS[fact.addend2]}?`;
}

/** Question speech text that matches the missing part format:
 *  sum:     "What is two plus one?"
 *  addend1: "What plus one equals three?"
 *  addend2: "Two plus what equals three?"
 */
export function factToMissingPartQuestionSpeechText(
  fact: AdditionFact,
  missingPart: 'sum' | 'addend1' | 'addend2'
): string {
  if (missingPart === 'sum') {
    return `What is ${NUMBER_WORDS[fact.addend1]} plus ${NUMBER_WORDS[fact.addend2]}?`;
  }
  if (missingPart === 'addend1') {
    return `What plus ${NUMBER_WORDS[fact.addend2]} equals ${NUMBER_WORDS[fact.sum]}?`;
  }
  return `${NUMBER_WORDS[fact.addend1]} plus what equals ${NUMBER_WORDS[fact.sum]}?`;
}
